import type { ReactNode } from 'react';
import { isFeatureEnabled } from 'common/features';
import {
  aboutPath,
  aboutContactDetailsPath,
  imprintPath,
  privacyPolicyPath
} from 'routes';

export type Props = {
  staticPagesEnabled: boolean;
};

function FooterLinkList(props: { children: ReactNode }) {
  return (
    <div className="m-search-results-footer">
      <ul>{props.children}</ul>
    </div>
  );
}

function LinkItem(props: {
  href: string;
  children: ReactNode;
  openInNewTab?: boolean;
}) {
  return (
    <li>
      <a href={props.href} target={props.openInNewTab ? '_blank' : undefined}>
        {props.children}
      </a>
    </li>
  );
}

export function SearchResultFooter(props: Props): ReactNode {
  // German law requires the Impressum to be reachable from every page, so the
  // link shows next to whichever other links this footer renders.
  const imprintLink = isFeatureEnabled('imprint') ? (
    <LinkItem href={imprintPath()} openInNewTab>
      {__('search.search_results.footer.imprint')}
    </LinkItem>
  ) : null;

  if (props.staticPagesEnabled) {
    return (
      <FooterLinkList>
        <LinkItem href={aboutPath()}>
          {__('search.search_results.footer.company')}
        </LinkItem>
        <LinkItem href={aboutContactDetailsPath()}>
          {__('search.search_results.footer.contact')}
        </LinkItem>
        <LinkItem href={privacyPolicyPath()} openInNewTab>
          {__('search.search_results.footer.privacy_policy')}
        </LinkItem>
        {imprintLink}
        <LinkItem href="https://venuu.se" openInNewTab>
          Venuu.se
        </LinkItem>
      </FooterLinkList>
    );
  } else {
    return (
      <FooterLinkList>
        <LinkItem href="https://venuu.se" openInNewTab>
          Venuu.se
        </LinkItem>
        <LinkItem href="https://venuu.fi" openInNewTab>
          Venuu.fi
        </LinkItem>
        {imprintLink}
      </FooterLinkList>
    );
  }
}
